import React from 'react';

export const MS_API = `${process.env.REACT_APP_BACKEND_URL}/api/material-sheets`;
export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const StatusPill = ({ s }) => {
  if (s.status === 'void') return <span className="px-2 py-0.5 rounded-full bg-slate-200 text-slate-700 text-[11px] font-bold uppercase" data-testid="ms-status-pill">Void</span>;
  if (s.status === 'issued' && s.needs_wo) return <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-[11px] font-bold uppercase" data-testid="ms-status-pill">Needs WO</span>;
  if (s.status === 'issued') return <span className="px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800 text-[11px] font-bold uppercase" data-testid="ms-status-pill">Issued</span>;
  return <span className="px-2 py-0.5 rounded-full bg-blue-100 text-blue-800 text-[11px] font-bold uppercase" data-testid="ms-status-pill">Draft</span>;
};
